export const userProfile = {
  username: "Όνομα Χρήστη",
  myProfile: "Το Προφίλ μου",
  myCompany: "Η Εταιρεία μου",
  detailedDescription: "Λεπτομερής Περιγραφή",
  myAccount: "Ο Λογαριασμός μου",
  uploadPhoto: "Ανέβασμα Φωτογραφίας",
  deleteProfile: "Διαγραφή Προφίλ;",
  areYouSureDeleteProfile:
    "Είστε σίγουροι ότι θέλετε να διαγράψετε το προφίλ σας; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί. Όλα τα δεδομένα σας θα διαγραφούν και δεν θα μπορείτε να τα ανακτήσετε.",
  profileDeletedSuccessfully: "Το προφίλ διαγράφηκε με επιτυχία",
  errorDeletingProfile: "Σφάλμα κατά τη διαγραφή του προφίλ. Παρακαλώ δοκιμάστε ξανά.",
  contactInfo: "Στοιχεία Επικοινωνίας",
  personalInfo: "Προσωπικά Στοιχεία",
  mobilePhone: "Κινητό Τηλέφωνο",
  telephone: "Τηλέφωνο",
};
